import React, { useEffect, useState } from 'react';
import haLogo from '../img/ha_logo.gif';
import { makeStyles } from "@mui/styles";
import { Typography, Grid, Paper, TextField, Button } from '@mui/material';
import LeaveDate from '../component/LeaveDate';
import moment from 'moment';
import * as _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import keyFile from '../utils/public.pem';
import { enTitle, cnTitle, enDisclaimer, cnDisclaimer, enReminder, cnReminder } from '../utils/static';


const useStyles = makeStyles((theme) => ({
    logo: {
        position: 'absolute',
        left: 5,
        verticalAlign: 'middle',
        [theme.breakpoints.down("sm")]: {
            position: 'relative',
            width: '32%',
            left: 0,
            top: 5
        }
    },
    title: {
        display: 'inline-block',
        //color: 'rgb(0, 112, 192)',
        color: '#ed3587',
        fontSize: 30,
        fontWeight: 'bold',
        left: 45,
        position: 'relative',
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '50%',
        [theme.breakpoints.down("md")]: {
            fontSize: 20,
            //left: 0,
            width: '50%'
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: 10,
            left: 0,
            width: '100%'
        }
    },
    star: {
        color: '#f44336'
    },
    paper: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        color: theme.palette.text.primary,
        borderRadius: "25px !important"
    },
    submitButton: {
        fontSize: 18,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
    },
    subTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        textDecoration: 'underline',
        marginBottom: 10
    }
}));



export default function ApplicationForm() {
    const classes = useStyles();
    const navigate = useNavigate();

    useEffect(() => {
        const paramName = window.location.search.slice(0, 6)
        if (!paramName || paramName !== '?data=') {
            navigate('/ScanCode');
        }
    }, [])

    const [formDetail, setFormDetial] = useState(
        {
            patientSurname:'',
            patientFirstname:'',
            //atientName: '',
            leaveDate: {
                toDate: moment().subtract(1, 'day').format('DD-MM-YYYY'),
                fromDate: moment().subtract(1, 'day').format('DD-MM-YYYY'),
                period: null
            }
        }
    )

    const handleChangeFormDetial = (e) => {
        setFormDetial(preVal => {
            return {
                ...formDetail,
                [e.target.name]: e.target.value
            }
        })
    }

    const [errorMsg, setErrorMsg] = useState([]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (validate()) {
            var verify = new JSEncrypt({ default_key_size: 2048 });


            fetch(keyFile).then(r => r.text()).then(t => {
                let pubKey = '';

                let submitForm = {
                    ...formDetail,
                    patientName: formDetail.patientFirstname.toUpperCase()?formDetail.patientSurname.toUpperCase()+", "+formDetail.patientFirstname.toUpperCase()
                                    :formDetail.patientSurname.toUpperCase()+","
                    //patientName: formDetail.patientName.toUpperCase()
                }
                pubKey = t.toString();
                pubKey = pubKey.replace("-----BEGIN PUBLIC KEY-----", "").replace("-----END PUBLIC KEY-----", "");

                verify.setPublicKey(pubKey);
                var signature = window.location.search.substring(6);
                const period = submitForm.leaveDate.period;
                const fromDate = moment(submitForm.leaveDate.fromDate, 'DD-MM-YYYY').format("DD-MMM-YYYY") + (period ? "  " + period : '');
                const toDate = moment(submitForm.leaveDate.toDate, 'DD-MM-YYYY').format("DD-MMM-YYYY") + (period ? "  " + period : '');
                var inputVal = submitForm.patientName + '|' + fromDate + '|' + toDate;

                try {
                    if (signature) {
                        var verified = verify.verify(inputVal, signature, CryptoJS.SHA256);
                        navigate('/Result', {
                            state: {
                                info: submitForm,
                                result: verified
                            }
                        });
                    } else {
                        console.error("Signature is null.")
                        navigate('/Result', {
                            state: {
                                info: submitForm,
                                result: false
                            }
                        });
                    }
                } catch (ex) {
                    console.error(ex)
                }
            });

        }
    }

    const validate = () => {
        let errorMsgList = [];
        let error = false;
        /* if (!formDetail.patientName) {
            errorMsgList.patientName = "required 必需填寫";
            error = true;
        } */
        if (!formDetail.patientSurname) {
            errorMsgList.patientSurname = "required 必需填寫";
            error = true;
        }
        /* if (!formDetail.patientFirstname) {
            errorMsgList.patientFirstname = "required 必需填寫";
            error = true;
        }
        */
        if (!formDetail.leaveDate.fromDate || !formDetail.leaveDate.toDate
            || formDetail.leaveDate.fromDate === "Invalid date" || formDetail.leaveDate.toDate === "Invalid date") {
            errorMsgList.leaveDate = "required 必需填寫";
            error = true;
        }

        if (error) {
            setErrorMsg(errorMsgList);
            return false;
        } else {
            setErrorMsg([]);
            return true;
        }
    }

    return <div>
        <div className="page-top-heading">
            <img src={haLogo} alt="logo" className={classes.logo} />
            <div className={classes.title}>
                {enTitle}
                <br />
                {cnTitle}
            </div>
        </div>
        <div style={{ marginLeft: "20px", marginRight: "20px", marginTop: "20px" }}>
            <div style={{ margin: "10px" }}>
                <Typography>
                    {enReminder}
                    <br />
                    {cnReminder}
                </Typography>
            </div>

            <Paper elevation={5} className={classes.paper}>
                <div className={classes.subTitle}>
                    Patient Information 病人資料
                </div>
                <Grid container spacing={2}>
                    <Grid item md={10} xs={12}>
                        <Grid item xs>
                            <span>
                                <span className={classes.star}>*</span>Surname 姓氏
                            </span>
                        </Grid>
                        <Grid item>
                            <TextField
                                id="patientSurname"
                                name="patientSurname"
                                value={formDetail.patientSurname}
                                onChange={(e) => handleChangeFormDetial(e)}
                                error={!!errorMsg.patientSurname}
                                helperText={
                                    errorMsg.patientSurname ? errorMsg.patientSurname : ""
                                }
                                variant="outlined"
                                size="small"
                                fullWidth
                                inputProps={{ maxLength: 48 }}
                                placeholder="E.g. Chan"
                            />
                        </Grid>
                        <Grid item xs>
                            <span>
                                {/* <span className={classes.star}>*</span> */}Given Name(s) 名
                            </span>
                        </Grid>
                        <Grid item>
                            <TextField
                                id="patientFirstname"
                                name="patientFirstname"
                                value={formDetail.patientFirstname}
                                onChange={(e) => handleChangeFormDetial(e)}
                                /*error={!!errorMsg.patientFirstname}
                                helperText={
                                    errorMsg.patientFirstname ? errorMsg.patientFirstname : ""
                                }*/
                                variant="outlined"
                                size="small"
                                fullWidth
                                inputProps={{ maxLength: 48 }}
                                placeholder="E.g. Tai Man"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs>
                            <span>
                                <span className={classes.star}>*</span>Sick Leave Date 病假日期 (DD-MM-YYYY)
                            </span>
                        </Grid>
                        <Grid item xs>
                            <LeaveDate
                                dateValue={formDetail.leaveDate}
                                endFieldName='toDate'
                                startFieldName='fromDate'
                                handleChangeDate={(val, fieldName) => {
                                    let newVal = _.cloneDeep(formDetail.leaveDate);
                                    newVal[fieldName] = val;
                                    if (!moment(newVal.fromDate, 'DD-MM-YYYY').isSame(moment(newVal.toDate, 'DD-MM-YYYY')) && fieldName !== "period") {
                                        newVal.period = null
                                    }

                                    setFormDetial(preVal => {
                                        if (fieldName === "fromDate" && val !== preVal.leaveDate.fromDate) {
                                            newVal.toDate = null;
                                        }
                                        return {
                                            ...preVal,
                                            leaveDate: newVal
                                        }
                                    });
                                }}
                                errorMsgList={errorMsg}
                                isMandatory={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            <Grid
                container
                wrap={"nowrap"}
                alignItems={"flex-start"}
                style={{ paddingTop: 15, color: '#f44336' }}
            >
                <Typography>
                    {enDisclaimer}
                    <br />
                    {cnDisclaimer}
                </Typography>
            </Grid>
            <div style={{ textAlign: "center", marginTop: 20 }}>
                <Button
                    id="submitBtn"
                    name="submitBtn"
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={handleSubmit}
                >
                    Confirm
                    <br />
                    確定
                </Button>
            </div>
        </div>
    </div >;
}